import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Field, Input } from "@hulahoop/ui";
import { OptionSelect } from "@/components/shared/forms/OptionSelect";
import type { BeneficiaryWizardFormData } from "@/domain/validation/beneficiarySchemas";
import { COMPANY_TYPES, INCENTIVE_TYPES } from "../config/beneficiaryCatalog";

export function CreateBeneficiaryLegalFields() {
  const { t } = useTranslation();
  const { register, control, formState } = useFormContext<BeneficiaryWizardFormData>();
  const errors = formState.errors;
  return (
    <>
      <Field label={t("promoters.wizard.legal_name")} required error={errors.name?.message}>
        <Input placeholder={t("promoters.wizard.legal_name_placeholder")} {...register("name")} />
      </Field>
      <div className="grid gap-(--card-gap) sm:grid-cols-2">
        <Field label={t("promoters.wizard.tax_id")} required error={errors.taxId?.message}>
          <Input placeholder={t("promoters.wizard.tax_id_placeholder")} {...register("taxId")} />
        </Field>
        <Field label={t("promoters.wizard.constitution")}>
          <Input type="date" {...register("constitutionDate")} />
        </Field>
      </div>
      <div className="grid gap-(--card-gap) sm:grid-cols-2">
        <Field
          label={t("promoters.wizard.company_type")}
          required
          error={errors.companyType?.message}
        >
          <Controller
            control={control}
            name="companyType"
            render={({ field }) => (
              <OptionSelect
                value={field.value}
                onValueChange={field.onChange}
                placeholder={t("promoters.wizard.select")}
                options={COMPANY_TYPES.map((option) => ({
                  value: option.value,
                  label: t(option.labelKey),
                }))}
                label={t("promoters.wizard.company_type")}
              />
            )}
          />
        </Field>
        <Field
          label={t("promoters.wizard.incentive_type")}
          required
          error={errors.incentiveType?.message}
        >
          <Controller
            control={control}
            name="incentiveType"
            render={({ field }) => (
              <OptionSelect
                value={field.value}
                onValueChange={field.onChange}
                placeholder={t("promoters.wizard.select")}
                options={INCENTIVE_TYPES.map((option) => ({
                  value: option.value,
                  label: t(option.labelKey),
                }))}
                label={t("promoters.wizard.incentive_type")}
              />
            )}
          />
        </Field>
      </div>
    </>
  );
}
